export default __webpack_public_path__ + "static/media/card-default.f0796e6e.png";